import type { FileUsage } from '@vedalib/editor/lib/files'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { IFileLoaderProps } from 'components/uiKit/FileLoader'
import FileLoader from 'components/uiKit/FileLoader'

const FieldFileId = ({
  name,
  defaultValue,
  value = defaultValue,
  onChange,
  ...rest
}: AdapterKitControlProps<IFileLoaderProps<FileUsage | null>, string | null>) => {
  const handleChange = useCallback(
    (value: FileUsage | null) => onChange({ name, value: value?.id || null }),
    [name, onChange],
  )

  return (
    <FileLoader
      {...rest}
      name={name}
      onChange={handleChange}
      value={typeof value === 'string' ? { id: value, type: FileUsageTypeEnum.image } : null}
    />
  )
}

export default React.memo(FieldFileId) as typeof FieldFileId
